import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "promptsContainer", "promptItem", "trainerInfo", "inputContainer", "cta"]
  static values = {
    prompts: Array
  }

  connect() {
    this.hidePrompts()
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('touchstart', this.handleClickOutside)
  }

  openInput(event) {
    event.stopPropagation()
    
    // Hide all trainer info elements and CTA
    if (this.hasTrainerInfoTarget) {
      this.trainerInfoTargets.forEach(target => {
        target.classList.add('hidden')
      })
    }
    if (this.hasCtaTarget) {
      this.ctaTarget.classList.add('hidden')
    }
    
    // Show input container
    if (this.hasInputContainerTarget) {
      this.inputContainerTarget.classList.remove('hidden')
    }
    
    // Focus on input
    if (this.hasInputTarget) {
      setTimeout(() => {
        this.inputTarget.focus()
      }, 100)
    }
    
    // Add click outside listener
    setTimeout(() => {
      document.addEventListener('click', this.handleClickOutside)
      document.addEventListener('touchstart', this.handleClickOutside)
    }, 100)
  }

  closeInput() {
    // Show all trainer info elements and CTA
    if (this.hasTrainerInfoTarget) {
      this.trainerInfoTargets.forEach(target => {
        target.classList.remove('hidden')
      })
    }
    if (this.hasCtaTarget) {
      this.ctaTarget.classList.remove('hidden')
    }
    
    // Hide input container
    if (this.hasInputContainerTarget) {
      this.inputContainerTarget.classList.add('hidden')
    }
    
    // Clear input and hide prompts
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
    }
    this.hidePrompts()
    
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('touchstart', this.handleClickOutside)
  }

  handleClickOutside(event) {
    // Check if click is outside the input container
    if (this.hasInputContainerTarget && 
        !this.inputContainerTarget.contains(event.target)) {
      this.closeInput()
    }
  }

  handleInput(event) {
    const input = event.target.value.trim().toLowerCase()
    
    if (input.length === 0) {
      this.hidePrompts()
      return
    }

    // Show prompts and filter them based on input
    this.showPrompts()
    this.filterPrompts(input)
  }

  filterPrompts(input) {
    this.promptItemTargets.forEach(prompt => {
      const label = prompt.dataset.label.toLowerCase()
      const shouldShow = label.includes(input) || input.includes(label.split(' ')[0])
      
      if (shouldShow) {
        prompt.classList.remove('hidden')
      } else {
        prompt.classList.add('hidden')
      }
    })

    // Check if all prompts are hidden, if so hide the container
    const visiblePrompts = this.promptItemTargets.filter(p => !p.classList.contains('hidden'))
    if (visiblePrompts.length === 0) {
      this.hidePrompts()
    }
  }

  showPrompts() {
    if (this.hasPromptsContainerTarget) {
      this.promptsContainerTarget.classList.remove('hidden')
    }
  }

  hidePrompts() {
    if (this.hasPromptsContainerTarget) {
      this.promptsContainerTarget.classList.add('hidden')
    }
  }

  selectPrompt(event) {
    event.stopPropagation()
    const slug = event.currentTarget.dataset.slug
    const label = event.currentTarget.dataset.label
    
    // Set the hidden slug field
    document.getElementById('slug').value = slug
    
    // Optionally set the input field text
    if (this.hasInputTarget) {
      this.inputTarget.value = label
    }
    
    // Submit the form
    document.getElementById('companion-form').submit()
  }
}
